/* src/app/shared/components/extracted-principal-info/extracted-principal-info.component.scss */
mat-card-header {
  margin-bottom: 20px;
}
mat-card-content label {
  min-width: 100px;
}
mat-card-content span,
mat-card-content a {
  font-weight: 600;
  color: #333;
  text-decoration: none;
}
mat-card-content > div {
  margin-top: 10px;
}
.principal-card.extracted {
  padding: 8px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.mat-card-title {
  font-weight: bold;
}
.mat-card-subtitle {
  color: gray;
}
.email a {
  color: #1976d2;
}
.email a:hover {
  text-decoration: underline;
}
/*# sourceMappingURL=extracted-principal-info.component.css.map */
